import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import BgImg from "../../images/business-automation/real-world-cta.webp";

function Realworldautomationcta() {
  return (
    <section className="real-world-automation-cta p-100 text_white">
      <Container>
        <div
          className="real-word-box"
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Row className="align-items-center h-100">
            <Col xs={12} md={12} lg={8} xl={8} xxl={7}>
              <h2>
                Some <span>Real-World</span> Automation Success
              </h2>
              <p>
                Discover how leading enterprises have boosted efficiency and
                profitability through TekRevol’s Business Automation Solutions.
              </p>
              <div className="real-word-main">
                <div className="real-world-item">
                  <div className="real-item-flex">
                    <div className="num">75%</div>
                    <div className="content">Reduction</div>
                  </div>
                  <p>in processing time for financial institutions.</p>
                </div>
                <div className="real-world-item">
                  <div className="real-item-flex">
                    <div className="num">60%</div>
                    <div className="content">Improvement</div>
                  </div>
                  <p>in accuracy for healthcare providers</p>
                </div>
                <div className="real-world-item">
                  <div className="real-item-flex">
                    <div className="num">40%</div>
                    <div className="content">cost savings</div>
                  </div>
                  <p>in retail operations.</p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Realworldautomationcta;
